<template>
    <div class="customers-view">
      <Spin fix class='ivu-spin-fullscreen' :class="{'dt-none': isLoading === false }">
        <Icon type="load-c" size=18 class="demo-spin-icon-load"></Icon>
        <div>{{loadingText}}</div>
      </Spin>
      <div class="content">
        <div class="nav">
            <span class="des">城市作战图</span>
            <!-- <Button @click="tabShowContro()" class="view-list">{{listText}}</Button> -->
            <Button v-show='showType ==="队员现有客户覆盖图"' @click="statisticsList" class="view-list">数据下载</Button>
            <Button v-show='showType ==="新老客户分布图"' @click="regionStatisticsList" class="view-list">数据下载</Button>
            <Select :key="cityName" v-model="cityName" style="width:150px" @on-change='changeCity(cityName)'>
                <Option v-for="item in cityList" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>

            <Select v-model="userType" style="width:150px" @on-change='changeUserType'>
                <Option v-for="item in userTypeList" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>

            <Select :key="userName" v-model="userName" style="width:150px" @on-change='changeMember(userName)'>
                <Option v-for="item in userList" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
            <Input icon="search" placeholder="搜索名称和ID" class="search" @on-change="input()" @on-enter="search()" @on-click="search()" v-model="searchKey"/>
            <i class="clear-input" v-show="clearInputFlag" @click="clearInput()">✖︎</i>
        </div>
        <div class="wrap-content" v-show="mapShow">
          <div class="map-content">
            <div class="content-left" :class="{'hidden-left': tabShow}" v-show='isShowLeftList'>
              <div class="list">
                <div v-for="(item,index) in tableDatas" @click="getMarker(index,item)" :class="{'item-active': index == isActive}">
                  <p>{{item.CustomerName}}</p>
                  <p>{{item.CustomerAddress}}</p>
                </div>
              </div>
              <Page :total="leftPageData.pageCount" :page-size="leftPageData.pageSize" :current="currentPage" @on-change="changePage" size="small" class-name="left-page" v-show="leftPageData.pageCount > leftPageData.pageSize"></Page>
            </div>
            <div class="content-right" ref='mapPanel' :class="isShowLeftList === false ? 'map-all' : ''">
              <div id='leaflet-map' class="inner-content"></div>
              <div class="legend-panel" v-show='legend.length > 0'>
                <p class='legend-title'>
                  <span>图例</span>
                  <Tooltip content="隐藏/显示图例" placement="top" class='pull-right'>
                    <Icon type="chevron-down" :class="isShowLegend === false ? 'reversal' : ''" ref='arrow' @click.native='isOpenLegend'></Icon>
                  </Tooltip>
                </p>
                <div class="legend-body" v-show='isShowLegend'>
                  <div class='marker-legend'>
                    <div class='legend-item' v-for="feature in legend"  @click='isShowFeature(feature.name)'>
                      <div class='draw-circle' v-if='feature.color' :style="feature.color"></div>
                      <img :src="feature.img" v-if='feature.img'>
                      <span style='float:left;'>&nbsp; {{feature.name}}({{feature.count}})</span>
                    </div>
                  </div>
                  <div class="region-legend">
                    <div class='legend-item' v-for="feature in legend" v-show='feature.regionStyle'  @click='isShowRegion(feature.name)'>
                      <div class='region-legend' v-if='feature.regionStyle' :style="feature.regionStyle"></div>
                      <span style='float:left;'>&nbsp; {{feature.name}}({{feature.count}})</span>
                    </div>
                  </div>
                </div>
              </div>
              <RadioGroup v-model="showType" type="button" class='marker-show-type' @on-change='changeShowType(showType)'>
                  <Radio label="队员现有客户覆盖图"></Radio>
                  <Radio label="新老客户分布图"></Radio>
              </RadioGroup>
              <Button type="ghost" v-model='listLeftText' class='list-btn'  @click="isOpenLeftList">{{listLeftText}}</Button>
              <!-- <Button type="ghost" class='statistics-btn' style='background-color:#fff;' v-show='showType ==="队员现有客户覆盖图"' @click="statisticsList">数据下载</Button>
              <Button type="ghost" class='statistics-btn' style='background-color:#fff;' v-show='showType ==="新老客户分布图"' @click="regionStatisticsList">数据下载</Button> -->
              <div class="statistics-panel" v-show='isOpenStatisticsPanel'>
                <p class='statistics-title'>
                  <span>客户统计信息</span>
                  <Icon type="close-round" @click.native='closeStatisticsPanel'></Icon>
                  <a href='javascript:void(0)' @click='downloadMember'>下载数据</a>
                </p>
                <Table border :columns="statisticsTab" :data="statisticsData"></Table>
                <Page :total="statisticsCount" :page-size="4" :current="1"  size='small' class='statistcs-page-control' @on-change="changeStatisticsPage"></Page>
              </div>
              <div class="region-statistics-panel" v-show='isOpenRegionStatisticsPanel'>
                <p class='statistics-title'>
                  <span>区域统计信息</span>
                  <Icon type="close-round" @click.native='closeRegionStatisticsPanel'></Icon>
                  <a href='javascript:void(0)' @click='downloadRegion'>下载数据</a>
                </p>
                <Table border :columns="regionStatisticsTab" :data="regionStatisticsData"></Table>
                <Page :total="regionStatisticsCount" :page-size="4" :current="regionCurrentPage"  size='small' class='statistcs-page-control' @on-change="changeRegionStatisticsPage"></Page>
              </div>
            </div>
          </div>
        </div>
        <div class="tab-content" v-show="tabShow">
          <div class="list-content table">
              <Table  border :columns="tableHeader" :data="tableDatas"></Table>
              <Page :total="leftPageData.pageCount" :page-size="leftPageData.pageSize" :current="currentPage" @on-change="changePage" size='small'></Page>
            </div>
        </div>
      </div>
    </div>
</template>
<script>
import api from "../service/api";
import getData from "../service/getData";
import "../assets/stylesheets/customers.scss";
import "../assets/javascript/jquery.min.js";
import "script-loader!../../resource/js/canvasRender.debug.js";
import "script-loader!../../resource/js/dt.hashmap.js";
import { createLayer, getColors } from "../assets/javascript/map_utils.js";
import { setTimeout } from "timers";

let osmurl =
  "https://webrd04.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=8&x={x}&y={y}&z={z}";
// "http://map.geoq.cn/ArcGIS/rest/services/ChinaOnlineStreetGray/MapServer/tile/{z}/{y}/{x}";

export default {
  data: function () {
    return {
      tabShow: false,
      mapShow: true,
      tableHeader: [],
      tableDatas: [],
      clearInputFlag: false,
      searchKey: "",
      defaultStatus: true,
      leftPageData: {
        pageCount: 0,
        pageSize: 20
      },
      layerGroup: new L.layerGroup([]),
      regionGroup: new L.layerGroup([]),
      userRegionGroup: new L.layerGroup([]),
      user_id: sessionStorage.getItem("userId"),
      currentPage: 1,
      selectedMarker: null,
      newIcon: {
        iconUrl: "../../static/images/f86767-s-circle.png",
        iconSize: [15, 24]
      },
      oldIcon: {
        iconUrl: "../../static/images/9c89cc-s-circle.png",
        iconSize: [15, 24]
      },
      selectedIcon: new L.icon({
        iconUrl: "../../static/images/icon_blue.png",
        iconSize: [25, 29]
      }),
      hideIcon: new L.icon({
        iconUrl: "../../static/images/cccccc-s-null.png",
        iconSize: [25, 29]
      }),
      cityName: "",
      userType: "BC",
      userName: "全部人员",
      cityList: [],
      userTypeList: [
        {
          value: "全部",
          label: "全部"
        },
        {
          value: "BC",
          label: "BC"
        },
        {
          value: "ABC",
          label: "ABC"
        }
      ],
      userTypeMap: new Map(),
      userList: [],
      hashMap: "",
      allMarkers: [],
      nMarkers: [],
      oMarkers: [],
      legend: [],
      newAndOldMarkers: [],
      showType: "队员现有客户覆盖图",
      allTabDatas: [],
      cityData: null,
      isLoading: false,
      loadingText: "加载中...",
      listText: "查看列表",
      selectItem: "",
      isActive: null,
      popup: null,
      currentDistricts: [],
      statisticsTab: [
        {
          title: "名称",
          key: "name",
          align: "center"
        },
        {
          title: "老客户",
          key: "oldCount",
          align: "center"
        },
        {
          title: "新客户",
          key: "newCount",
          align: "center"
        },
        {
          title: "共计",
          key: "totalCount",
          align: "center"
        }
      ],
      regionStatisticsTab: [
        { title: "区域名称", key: "name", align: "center" },
        { title: "老客户", key: "oldCount", align: "center" },
        { title: "新客户", key: "newCount", align: "center" },
        { title: "共计", key: "totalCount", align: "center" }
      ],
      regionStatisticsResult: [],
      statisticsData: [],
      regionStatisticsData: [],
      statisticsCount: 0,
      regionStatisticsCount: 0,
      isOpenStatisticsPanel: false,
      isOpenRegionStatisticsPanel: false,
      regionCurrentPage: 1,
      listLeftText: "收起列表",
      isShowLeftList: true,
      isShowLegend: true,
      labelOptions: {
        permanent: true,
        direction: "right",
        className: "leaflet-black-label"
      }
    };
  },
  mounted () {
    this.hashMap = new DT.HashMap();
    this.createPageControl($(".ivu-page")[0]);
    this.createPageControl($(".ivu-page")[3]);

    this.map = L.map("leaflet-map", {
      center: [39.91582, 116.402831],
      zoom: 10,
      minZoom: 1,
      maxZoom: 18,
      projection: L.Projection.LonLat,
      attributionControl: false,
      zoomControl: false
    });
    this.map.canvasLayer = new L.R.Canvas(this.map, {
      zIndex: 999999,
      showAll: true
    });
    L.tileLayer(osmurl).addTo(this.map);
    L.control
    .zoom({
      position: "bottomright",
      zoomInTitle: "放大",
      zoomOutTitle: "缩小"
    })
    .addTo(this.map);
    L.control
    .scale({
      position: "bottomright",
      imperial: false
    })
    .addTo(this.map);
    this.layerGroup.addTo(this.map);
    this.regionGroup.addTo(this.map);
    this.userRegionGroup.addTo(this.map);
    let self = this;
    this.map.on("popupclose", function () {
      self.layerGroup.clearLayers();
      self.selectItem = "";
      self.popup = null;
    });
    this.map.on("click", function () {
      self.isActive = null;
    });
    this.getCustCity();
    $(document).on("select_feature", function (e, target) {
      self.openPopup(target);
    });
  },
  methods: {
    isOpenLegend () {
      this.isShowLegend = !this.isShowLegend;
    },
    isOpenLeftList () {
      let mapClass = this.$refs.mapPanel.className;
      let self = this;
      if (mapClass.indexOf("map-all") >= 0) {
        this.$refs.mapPanel.classList.remove("map-all");
        setTimeout(function () {
          self.isShowLeftList = !self.isShowLeftList;
        }, 1000);
      } else {
        this.isShowLeftList = !this.isShowLeftList;
      }

      if (this.listLeftText === "收起列表") {
        this.listLeftText = "打开列表";
      } else {
        this.listLeftText = "收起列表";
      }
      setTimeout(function () {
        self.map.invalidateSize(true, { debounceMoveend: true });
      }, 1000);
    },
    _getUserId () {
      let userId = "";
      let users = eval(sessionStorage.getItem("users"));
      for (let i = 0; i < users.length; i++) {
        if (users[i].value === this.userName) {
          userId = users[i].key;
          break;
        }
      }
      return userId;
    },
    _getUserIds () {
      let userIds = [];
      let users = eval(sessionStorage.getItem("users"));
      let names = [];
      for (let n = 0; n < this.userList.length; n++) {
        names.push(this.userList[n].value);
      }
      for (let i = 0; i < users.length; i++) {
        if (names.indexOf(users[i].value) >= 0) {
          userIds.push(users[i].key);
        }
      }
      return userIds;
    },
    downloadRegion () {
      let userIds = [];
      if (this.userName === "全部人员") {
        userIds = this._getUserIds();
      } else {
        userIds.push(this._getUserId());
      }
      let params = {
        userIds: JSON.stringify(userIds),
        city: this.cityName
      };
      window.open(
        `https://schedule.dituwuyou.com/api/customers/count_district?city=${
          params.city
        }&userIds=${params.userIds}`
      );
    },
    downloadMember: async function () {
      let userIds = this._getUserIds();
      let params = {
        userIds: JSON.stringify(userIds),
        city: this.cityName
      };
      window.open(
        `https://schedule.dituwuyou.com/api/customers/count_customer?city=${
          params.city
        }&userIds=${params.userIds}`
      );

      // const res = await getData.get(
      //   `/api/customers/count_customer?city=${params.city}&userIds=${
      //     params.userIds
      //   }`,
      //   null
      // );

      // const BOM = Buffer.from("\uFEFF");
      // const bomCsv = Buffer.concat([BOM, Buffer.from(res.data)]);
      // const csv = bomCsv.toString();

      // var blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      // if (navigator.msSaveBlob) {
      //   // IE 10+
      //   navigator.msSaveBlob(blob, "csvname.csv");
      // } else {
      //   var link = document.createElement("a");
      //   if (link.download !== undefined) {
      //     var url = URL.createObjectURL(blob);
      //     link.setAttribute("href", url);
      //     link.setAttribute("download", "csvname.csv");
      //     link.style = "visibility:hidden";
      //     document.body.appendChild(link);
      //     link.click();
      //     document.body.removeChild(link);
      //   }
      // }
    },
    closeStatisticsPanel () {
      this.isOpenStatisticsPanel = !this.isOpenStatisticsPanel;
    },
    closeRegionStatisticsPanel () {
      this.isOpenRegionStatisticsPanel = !this.isOpenRegionStatisticsPanel;
    },
    regionStatisticsList () {
      this.isOpenRegionStatisticsPanel = !this.isOpenRegionStatisticsPanel;
    },
    statisticsList () {
      this.isOpenStatisticsPanel = !this.isOpenStatisticsPanel;
      let data = [];
      let layers = this.hashMap.values();
      for (let i = 0; i < layers.length; i++) {
        let layer = layers[i];
        if (layer.id !== "新客户" && layer.id !== "老客户") {
          if (data.length < 4) {
            data.push({
              name: layer.id,
              oldCount: layer.oldMarkers.length,
              newCount: layer.getFeatures().length - layer.oldMarkers.length,
              totalCount: layer.getFeatures().length
            });
          }
        }
      }
      this.statisticsData = data;
      this.statisticsCount = layers.length;
    },
    isShowRegion (name) {
      let layer = this.hashMap.get(name);
      for (let i = 0; i < this.legend.length; i++) {
        if (this.legend[i].name === name) {
          if (this.legend[i].regionStyle.indexOf("gray") >= 0) {
            let regionColor = `#${layer.oldMarkers[0].color}`.colorRgb(0.2);
            this.legend[i].regionStyle = `border:1px solid #${
              layer.oldMarkers[0].color
            };background:${regionColor}`;
            if (!this.userRegionGroup.hasLayer(layer.polygon)) {
              this.userRegionGroup.addLayer(layer.polygon);
            }
          } else {
            this.legend[
            i
            ].regionStyle = `border:1px solid gray;background-color:gray;`;
            if (this.userRegionGroup.hasLayer(layer.polygon)) {
              this.userRegionGroup.removeLayer(layer.polygon);
            }
          }
        }
      }
    },
    isShowFeature (name) {
      let layer = this.hashMap.get(name);
      let markers;
      if (this.showType === "队员现有客户覆盖图") {
        markers = layer.oldMarkers;
      } else {
        markers = layer.getFeatures();
      }
      if (this.showType === "队员现有客户覆盖图") {
        for (let i = 0; i < this.legend.length; i++) {
          if (this.legend[i].name === name) {
            if (this.legend[i].color.indexOf("gray") >= 0) {
              this.legend[i].color = `background-color:#${
                layer.getFeatures()[0].color
              };`;
              layer.setData(markers);
            } else {
              this.legend[i].color = `background-color:gray;`;
              layer.setData([]);
            }
          }
        }
      } else {
        for (let i = 0; i < this.legend.length; i++) {
          if (this.legend[i].name === name) {
            if (this.legend[i].img.indexOf("cccccc") >= 0) {
              if (layer.id === "新客户") {
                this.legend[i].img = this.newIcon.iconUrl;
              } else {
                this.legend[i].img = this.oldIcon.iconUrl;
              }
              layer.setData(layer.getFeatures());
            } else {
              this.legend[i].img = "../../static/images/cccccc-s-null.png";
              layer.setData([]);
            }
          }
        }
      }
    },
    createPageControl (dom) {
      let leftPage = dom;
      let firstLi = $(leftPage).find(":first-child a");
      firstLi.html("上一页");
      $(leftPage)
      .find(":last-child a")
      .html("下一页");
      let firstPage = document.createElement("li");
      let lastPage = document.createElement("li");
      firstPage.innerHTML = "<a>首页</a>";
      lastPage.innerHTML = "<a>尾页</a>";
      firstPage.className = "ivu-page-prev";
      lastPage.className = "ivu-page-next";
      leftPage.insertBefore(firstPage, leftPage.childNodes[0]);
      leftPage.appendChild(lastPage);
      let self = this;
      firstPage.onclick = () => {
        if (self.currentPage === 1) {
          return;
        }
        self.changePage(1);
      };
      lastPage.onclick = () => {
        let lastPage =
          parseInt(self.leftPageData.pageCount / self.leftPageData.pageSize) +
          1;
        if (self.currentPage === lastPage) {
          return;
        }
        self.changePage(lastPage);
      };
    },
    tabShowContro () {
      //控制列表的显示和隐藏
      this.tabShow = !this.tabShow;
      if (this.tabShow) {
        this.listText = "查看地图";
      } else {
        this.listText = "查看列表";
      }
      this.mapShow = !this.mapShow;
    },
    getMarker (index, target) {
      this.isActive = index;
      this.selectItem = "select-item-active";
      if (target.id) {
        this.map.closePopup();
        let layer_id = target.SR;
        let layer = this.hashMap.get(layer_id);
        let marker = layer.getFeature(target.id);
        if (marker) {
          this.openPopup(marker);
        }
      }
    },
    getCustomers: async function (data) {
      const res = await getData.get(data.api, data);
      if (res && res.data && res.data.status) {
        this.allTabDatas = this.tableDatas;
        this.tableDatas = [];
        let formatCustomers = [];
        let customers = res.data.customers;
        for (let i = 0; i < customers.length; i++) {
          let marker = customers[i];
          marker.attrs["id"] = marker.id;
          marker.attrs["layer_id"] = marker.attrs.SR;
          formatCustomers.push(marker.attrs);
        }
        //请求成功渲染点
        // this.addMarker(res.data.customers);
        this.tableDatas = formatCustomers;
        this.currentPage = 1;
        this.leftPageData.pageCount = res.data.allCount;
      }
      this.closeLoading();
    },
    getCustCity: async function () {
      //获取城市列表
      const params = {
        userIds: sessionStorage.getItem("userIds"),
        returnId: true
      };
      this.cityList = [];
      const res = await getData.post(api.custCity, params);
      if (res.data && res.data.status) {
        for (let city in res.data.city) {
          if (this.cityName.length === 0) {
            this.cityName = city;
          }
          this.cityList.push({
            value: city,
            label: city
          });
        }
        this.cityData = res.data.city;
      } else {
        this.closeLoading();
        this.$Message.info("暂无客户数据");
      }
      this.getMembers();
    },
    getDistrictCount: async function () {
      let userIds = this._getUserIds();
      let userName = "";
      if (this.userName !== "全部人员") {
        userName = this.userName;
      }
      let params = {
        userIds: JSON.stringify(userIds),
        city: this.cityName,
        user_name: userName
      };
      const res = await getData.get(api.districtCount, params);
      if (res && res.data && res.data.status) {
        this.regionStatisticsResult = [];
        let formatRegions = [];
        let countyCounts = res.data.countyCounts;
        for (let i = 0; i < countyCounts.length; i++) {
          let result = countyCounts[i];
          this.regionStatisticsResult.push(result);
          if (formatRegions.length < 4) {
            formatRegions.push({
              name: result.key,
              oldCount: result.value.oldCount,
              newCount: result.value.newCount,
              totalCount: result.value.oldCount + result.value.newCount
            });
          }
        }
        this.regionStatisticsData = formatRegions;
        this.regionStatisticsCount = this.regionStatisticsResult.length;
        this.regionCurrentPage = 1;
      }
    },
    getDistrict: async function () {
      this.regionGroup.clearLayers();
      this.userRegionGroup.clearLayers();
      this.currentDistricts = [];
      const params = {
        city: this.cityName
      };
      const res = await getData.get(api.district, params);
      let self = this;
      if (res && res.data && res.data.status) {
        let regions = res.data.districts[0].children;
        for (let i = 0; regions && i < regions.length; i++) {
          let region = L.geoJSON(regions[i].geom);
          region.name = regions[i].name;
          region.on("click", function (e) {
            let latlng = e.latlng;
            let region = this;
            setTimeout(function () {
              if (self.popup && self.popup.isOpen()) {
                return;
              }
              self.popup = L.popup({
                className: "popupStyle"
              })
              .setLatLng(latlng)
              .setContent(region.name)
              .openOn(self.map);
            }, 200);
          });
          this.addLabel(region);
          this.currentDistricts.push(region);
          // this.regionGroup.addLayer(region);
        }
      }
    },
    addLabel (region) {
      region.bindTooltip(region.name, this.labelOptions);
    },
    getAllMarkers: async function () {
      let params = {
        city: this.cityName,
        userIds: sessionStorage.getItem("userIds")
      };
      this.tableHeader = [];
      const res = await getData.post(api.markers, params);
      if (res.data && res.data.status) {
        let oldMarkers = res.data.oldCustomers;
        let newMarkers = res.data.newCustomers;
        let markers = oldMarkers.concat(newMarkers);
        let polygons = res.data.polygons;
        if (!this.tableHeader.length && markers[0]) {
          for (const key in markers[0].attrs) {
            if (key !== "type") {
              this.tableHeader.push({
                title: key,
                key: key,
                width: 160,
                align: "center"
              });
            }
          }
        }
        // let formatCustomers = []; //表格展示中用到的
        // for (const marker of markers) {
        //   let showAttr = {};
        //   this.tableHeader.forEach(item => {
        //     showAttr[item.key] = marker.attrs[item.key];
        //   });
        // // formatCustomers.push(showAttr);
        // }
        this.leftPageData.pageCount = oldMarkers.length;
        this.allMarkers = markers;
        this.oMarkers = [];
        this.nMarkers = [];
        let colorArray = getColors(this.userList.length - 1);
        for (let i = 0; i < markers.length; i++) {
          let marker = markers[i];
          let index = this.getMemberIndex(marker.srName);
          let color = colorArray[index - 1];
          // let icon = {
          //   iconUrl: `/static/images/${ color }-s-null.png`,
          //   iconSize: [17, 27]
          // };
          let latlng = L.latLng(
            marker.point.coordinates[1],
            marker.point.coordinates[0]
          );
          let canvasMarker = new L.marker(latlng);
          canvasMarker.attrs = marker.attrs;
          canvasMarker.type = "Canvas";
          canvasMarker.attrs["id"] = marker.id;
          canvasMarker.icon = {
            draw: this.drawCircle,
            iconSize: [12, 12],
            iconAnchor: [0, 0],
            drawParams: { color: `#${color}` }
          };
          canvasMarker.color = color;
          canvasMarker.normalIcon = canvasMarker.icon;
          canvasMarker.id = marker.id;
          if (canvasMarker.attrs.OTMClass === "P") {
            canvasMarker.kind = "new";
            this.nMarkers.push(canvasMarker);
          } else {
            canvasMarker.kind = "old";
            this.oMarkers.push(canvasMarker);
          }
          canvasMarker.newIcon = this.newIcon;
          canvasMarker.oldIcon = this.oldIcon;
          canvasMarker.layer_id = marker.srName;
          canvasMarker.x = marker.point.coordinates[0];
          canvasMarker.y = marker.point.coordinates[1];
          if (this.hashMap.containsKey(marker.srName)) {
            this.hashMap
            .get(marker.srName)
            .markers.put(canvasMarker.id, canvasMarker);
          }
        }
        // this.tableDatas = formatCustomers;
        let self = this;
        polygons.forEach(function (item) {
          for (let key in item) {
            let layer = self.hashMap.get(key);
            if (layer) {
              let color = layer.getFeatures()[0].color;
              layer.polygonColor = `#${color}`;
              layer.polygon = item[key];
            }
          }
        });
        this.addMarkersToMap();
      }
    },
    drawCircle (iconSize, params) {
      let color = params.color;
      let box = new createjs.Shape();
      let len = iconSize[0] / 2;
      box.graphics.beginFill(color).drawCircle(0, 0, len);
      return box;
    },
    addMarkersToMap: function () {
      let formatCustomers = [];
      let layers = this.hashMap.values();
      for (let i = 0; i < layers.length; i++) {
        let layer = layers[i];
        let oldMarkers = [];
        let newMarkers = [];
        let markers = layer.getFeatures();
        for (let m = 0; m < markers.length; m++) {
          if (markers[m].kind === "old") {
            oldMarkers.push(markers[m]);
            if (formatCustomers.length < this.leftPageData.pageSize) {
              formatCustomers.push(markers[m].attrs);
            }
          } else {
            newMarkers.push(markers[m]);
          }
        }
        layer.oldMarkers = oldMarkers;
        layer.newMarkers = newMarkers;
        // layer.setData(layer.getFeatures());
        if (!layer.polygon) continue;
        let region = L.geoJSON(layer.polygon, {
          style: function (feature) {
            return {
              fillColor: layer.polygonColor,
              fillOpacity: 0.3,
              color: layer.polygonColor,
              opacity: 0.5
            };
          }
        });
        layer.polygon = region;
        layer.setData(oldMarkers);
        this.userRegionGroup.addLayer(region);
      }
      this.tableDatas = formatCustomers;
      this.createLegend();
      this.closeLoading();
    },
    _createLegendPanel (layer) {
      if (layer.oldMarkers.length !== 0) {
        let regionColor = `#${layer.oldMarkers[0].color}`.colorRgb(0.2);
        this.legend.push({
          color: `background-color:#${layer.oldMarkers[0].color};`,
          name: layer.id,
          count: layer.oldMarkers.length,
          regionStyle: `border:1px solid #${
            layer.oldMarkers[0].color
          };background-color:${regionColor}`
        });
      }
    },
    createLegend () {
      let layers = this.hashMap.values();
      this.legend = [];
      let newIconCount = 0;
      let oldIconCount = 0;
      for (let i = 0; i < layers.length; i++) {
        let layer = layers[i];
        if (
          layer.showType === "member" &&
          layer.id !== "新客户" &&
          layer.id !== "老客户"
        ) {
          if (this.userName === "全部人员") {
            this._createLegendPanel(layer);
          } else if (this.userName === layer.id) {
            this._createLegendPanel(layer);
          }
        } else if (layer.showType === "guest") {
          if (["新客户", "老客户"].indexOf(layer.id) === -1) {
            continue;
          }
          let markers = layer.getFeatures();
          for (let j = 0; j < markers.length; j++) {
            let marker = markers[j];
            if (marker) {
              if (this.userName === "全部人员") {
                if (
                  marker.icon.iconUrl &&
                  marker.icon.iconUrl.indexOf("f86767-s-circle") >= 0
                ) {
                  newIconCount++;
                } else if (
                  marker.icon.iconUrl &&
                  marker.icon.iconUrl.indexOf("9c89cc-s-circle") >= 0
                ) {
                  oldIconCount++;
                }
              } else {
                if (
                  marker.icon.iconUrl &&
                  marker.icon.iconUrl.indexOf("f86767-s-circle") >= 0
                ) {
                  newIconCount++;
                } else if (
                  marker.icon.iconUrl &&
                  marker.icon.iconUrl.indexOf("9c89cc-s-circle") >= 0
                ) {
                  oldIconCount++;
                }
              }
            }
          }
        }
      }
      if (this.legend.length === 0 && this.showType === "新老客户分布图") {
        this.legend.push(
          {
            img: this.newIcon.iconUrl,
            name: "新客户",
            count: newIconCount
          },
          {
            img: this.oldIcon.iconUrl,
            name: "老客户",
            count: oldIconCount
          }
        );
      }
      this.fitBounds();
    },
    getMemberIndex (member) {
      let index = null;
      for (let i = 1; i < this.userList.length; i++) {
        if (member === this.userList[i].value) {
          index = i;
          break;
        }
      }
      return index;
    },
    getMembers () {
      this.openLoading("加载中，请稍后...");
      this.getDistrict();
      let members = [];
      if (this.cityData && this.cityName) {
        members = this.cityData[this.cityName];
      }

      this.userTypeMap.set("BC", []); //先清空
      this.userTypeMap.set("ABC", []);
      this.userTypeMap.set("全部", []);

      for (let i = 0; members && i < members.length; i++) {
        const user = members[i];
        this.userTypeMap.get("全部").push(user);
        if (user.srCode.startsWith("NP")) {
          //ABC人员
          this.userTypeMap.get("ABC").push(user);
        } else {
          this.userTypeMap.get("BC").push(user);
        }
      }
      this.userType = "全部";
      this.changeUserType("全部");
    },
    changeUserType (userType) {
      //改变人员类别
      this.userRegionGroup.clearLayers();
      this.userList = [];
      this.userName = "全部人员";
      let layers = this.hashMap.values();
      if (layers.length > 0) {
        for (let l = 0; l < layers.length; l++) {
          layers[l].setData([]);
        }
      }
      this.hashMap.clear();
      let users = [];

      users = this.userTypeMap.get(userType);
      for (let i = 0; i < users.length; i++) {
        const user = users[i];
        if (i === 0) {
          this.userList.push(
            {
              value: "全部人员",
              label: "全部人员"
            },
            {
              value: user.name,
              label: user.name
            }
          );
        } else {
          this.userList.push({
            value: user.name,
            label: user.name
          });
        }
        let layer = createLayer(this.map.canvasLayer, user.name);
        layer.showType = "member";
        layer.setCanvasOptions();
        layer.setData([]);
        this.hashMap.put(user.name, layer);
      }
      let nLayer = createLayer(this.map.canvasLayer, "新客户");
      nLayer.showType = "guest";
      nLayer.setCanvasOptions();
      nLayer.setData([]);
      let oLayer = createLayer(this.map.canvasLayer, "老客户");
      oLayer.showType = "guest";
      oLayer.setCanvasOptions();
      oLayer.setData([]);
      this.hashMap.put("新客户", nLayer);
      this.hashMap.put("老客户", oLayer);
      this.getAllMarkers();
    },
    input () {
      this.clearInputFlag = this.searchKey !== "";
    },
    search () {
      if (this.searchKey === "") {
        this.$Message.info("搜索内容不能为空");
        return false;
      }
      this.defaultStatus = false;
      this.tabShow = false;
      this.openLoading("搜索中,请稍后...");
      let userName = this.userName === "全部人员" ? "" : this.userName;
      this.getCustomers({
        api: api.customersSearch,
        userIds: sessionStorage.getItem("userIds"),
        key: this.searchKey,
        user_name: userName
      });
    },
    clearInput () {
      this.searchKey = "";
      this.clearInputFlag = false;
      this.currentPage = 1;
      if (!this.defaultStatus) {
        if (this.userName === "全部人员") {
          this.tableDatas = this.allTabDatas;
          this.leftPageData.pageCount = this.allMarkers.length;
          this.defaultStatus = true;
        } else {
          let layer = this.hashMap.get(this.userName);
          let formatCustomers = [];
          if (layer) {
            let markers = layer.getFeatures();
            let len =
              markers.length > this.leftPageData.pageSize
                ? this.leftPageData.pageSize
                : markers.length;
            for (let m = 0; m < len; m++) {
              formatCustomers.push(markers[m].attrs);
            }
            this.tableDatas = formatCustomers;
            this.leftPageData.pageCount = markers.length;
          }
        }
      }
    },
    openPopup (target) {
      let marker = new L.marker(target.getLatLng(), {
        icon: this.selectedIcon
      });
      this.layerGroup.addLayer(marker);
      this.popup = L.popup({
        className: "popupStyle"
      })
      .setLatLng(target.getLatLng())
      .setContent(
        `<div class="popup">
                      <p>${target.attrs.CustomerName}</p>
                      <p><span>地址</span><span>${
  target.attrs.CustomerAddress
}</span></p>
                      <p><span>负责人</span><span>${target.attrs.SR}</span></p>
                      <p><span>SRCode</span><span>${
  target.attrs.SRCode
}</span></p>
                      <p><span>OTM</span><span>${
  target.attrs.OTMClass
}</span></p>
                    </div>`
      )
      .openOn(this.map);
    },
    changeRegionStatisticsPage (page) {
      let start, end;
      if (page === 1) {
        start = 0;
        end = 4;
      } else {
        start = 4 * page - 4;
        end = start + 4;
        if (this.currentDistricts.length < end) {
          end = this.currentDistricts.length;
        }
      }
      let data = [];
      for (let i = start; i < end; i++) {
        data.push({
          name: this.regionStatisticsResult[i].key,
          oldCount: this.regionStatisticsResult[i].value.oldCount,
          newCount: this.regionStatisticsResult[i].value.newCount,
          totalCount:
            this.regionStatisticsResult[i].value.oldCount +
            this.regionStatisticsResult[i].value.newCount
        });
      }
      this.regionStatisticsData = data;
      this.regionCurrentPage = page;
    },
    changeStatisticsPage (page) {
      let start, end;
      let layers = this.hashMap.values();
      if (page === 1) {
        start = 0;
        end = 4;
      } else {
        start = 4 * page - 4;
        end = start + 4;
        if (layers.length < end) {
          end = layers.length;
        }
      }
      let data = [];
      for (let i = start; i < end; i++) {
        if (layers[i].id !== "新客户" && layers[i].id !== "老客户") {
          data.push({
            name: layers[i].id,
            oldCount: layers[i].oldMarkers.length,
            newCount:
              layers[i].getFeatures().length - layers[i].oldMarkers.length,
            totalCount: layers[i].getFeatures().length
          });
        }
      }
      this.statisticsData = data;
    },
    changePage (page) {
      let start, end;
      if (page === 1) {
        start = 0;
        end = this.leftPageData.pageSize;
      } else {
        start = this.leftPageData.pageSize * page - this.leftPageData.pageSize;
        end = start + this.leftPageData.pageSize;
        if (this.leftPageData.pageCount < end) {
          end = this.leftPageData.pageCount;
        }
      }
      let formatCustomers = [];
      if (this.userName === "全部人员") {
        for (let i = start; i < end; i++) {
          formatCustomers.push(this.allMarkers[i].attrs);
        }
      } else {
        let layer = this.hashMap.get(this.userName);
        if (layer) {
          let markers = layer.getFeatures();
          for (let i = start; i < end; i++) {
            formatCustomers.push(markers[i].attrs);
          }
        }
      }

      this.tableDatas = formatCustomers;
      this.currentPage = page;
      $(".content-left").scrollTop(0);
      this.map.closePopup();
    },
    changeCity (cityName) {
      this.clearInput();
      this.showType = "队员现有客户覆盖图";
      this.cityName = cityName;
      this.getMembers();
      this.map.closePopup();
    },
    changeMember (member) {
      this.clearInput();
      let layers = this.hashMap.values();
      if (this.showType === "队员现有客户覆盖图") {
        this._showMemberMarkers(layers, member);
      } else if (this.showType === "新老客户分布图") {
        this.getDistrictCount();
        this._showDistributeMarkers(layers, member);
      }
      if (member === "全部人员" && this.showType === "队员现有客户覆盖图") {
        this.leftPageData.pageCount = this.oMarkers.length;
      } else if (member === "全部人员" && this.showType === "新老客户分布图") {
        this.leftPageData.pageCount = this.allMarkers.length;
      }

      this.createLegend();
      this.map.closePopup();
    },
    _showMemberMarkers (layers, member) {
      let formatCustomers = [];
      for (let i = 0; i < layers.length; i++) {
        let layer = layers[i];
        let markers = layer.oldMarkers;

        if (member === "全部人员") {
          if (markers.length === 0) {
            layer.setData([]);
            continue;
          }
          for (let k = 0; k < this.leftPageData.pageSize; k++) {
            formatCustomers.push(markers[k].attrs);
          }
          layer.setData(markers);
          if (!this.userRegionGroup.hasLayer(layer.polygon)) {
            this.userRegionGroup.addLayer(layer.polygon);
          }
        } else if (member === layer.id) {
          this.leftPageData.pageCount = markers.length;
          if (markers.length === 0) {
            layer.setData([]);
            continue;
          }
          for (let k = 0; k < this.leftPageData.pageSize; k++) {
            formatCustomers.push(markers[k].attrs);
          }
          layer.setData(markers);
          if (!this.userRegionGroup.hasLayer(layer.polygon)) {
            this.userRegionGroup.addLayer(layer.polygon);
          }
        } else {
          layer.setData([]);
          if (this.userRegionGroup.hasLayer(layer.polygon)) {
            this.userRegionGroup.removeLayer(layer.polygon);
          }
        }
      }
      this.tableDatas = formatCustomers;
      this.currentPage = 1;
    },
    _showDistributeMarkers (layers, member) {
      this.newAndOldMarkers = [];
      for (let i = 0; i < layers.length; i++) {
        let layer = layers[i];
        layer.showType = "guest";
        layer.setData([]);
      }
      let newMks, oldMks;
      this.hashMap.get("新客户").clearHashMap();
      this.hashMap.get("老客户").clearHashMap();
      if (this.userName === "全部人员") {
        newMks = this.nMarkers;
        oldMks = this.oMarkers;
      } else {
        newMks = this.hashMap.get(member).newMarkers;
        oldMks = this.hashMap.get(member).oldMarkers;
      }
      this.newAndOldMarkers = newMks.concat(oldMks);
      for (let n = 0; n < newMks.length; n++) {
        newMks[n].icon = this.newIcon;
        this.hashMap.get("新客户").markers.put(newMks[n].id, newMks[n]);
      }
      for (let o = 0; o < oldMks.length; o++) {
        oldMks[o].icon = this.oldIcon;
        this.hashMap.get("老客户").markers.put(oldMks[o].id, oldMks[o]);
      }
      this.hashMap.get("新客户").setData(newMks);
      this.hashMap.get("老客户").setData(oldMks);
      let formatCustomers = [];
      this.leftPageData.pageCount = this.newAndOldMarkers.length;
      for (let l = 0; l < this.leftPageData.pageSize; l++) {
        if (this.newAndOldMarkers[l]) {
          formatCustomers.push(this.newAndOldMarkers[l].attrs);
        }
      }
      this.tableDatas = formatCustomers;
      this.currentPage = 1;
    },
    changeShowType (showType) {
      let layers = this.hashMap.values();
      let formatCustomers = [];
      this.tableDatas = [];
      if (showType === "新老客户分布图") {
        this.isOpenStatisticsPanel = false;
        this.userRegionGroup.clearLayers();
        for (let d = 0; d < this.currentDistricts.length; d++) {
          this.regionGroup.addLayer(this.currentDistricts[d]);
        }
        this._showDistributeMarkers(layers, this.userName);
      } else {
        this.isOpenRegionStatisticsPanel = false;
        this.hashMap.get("新客户").clearHashMap();
        this.hashMap.get("老客户").clearHashMap();
        this.regionGroup.clearLayers();
        for (let i = 0; i < layers.length; i++) {
          let layer = layers[i];
          layer.showType = "member";
          let markers = layer.oldMarkers;
          for (let j = 0; j < markers.length; j++) {
            let marker = markers[j];
            marker.icon = marker.normalIcon;
          }
          console.log(`${this.userName}  ${layer.id}`);
          if (this.userName === "全部人员") {
            layer.setData(markers);
            if (layer.polygon) {
              this.userRegionGroup.addLayer(layer.polygon);
            }
          } else if (this.userName === layer.id) {
            this.leftPageData.pageCount = markers.length;
            for (let m = 0; m < markers.length; m++) {
              if (formatCustomers.length < this.leftPageData.pageSize) {
                formatCustomers.push(markers[m].attrs);
              }
            }
            layer.setData(markers);
            this.userRegionGroup.addLayer(layer.polygon);
          } else {
            layer.setData([]);
          }

          // layers[i].showType = "member";
          // let markers = layers[i].oldMarkers;
          // for (let j = 0; j < markers.length; j++) {
          //   let marker = markers[j];
          //   marker.icon = marker.normalIcon;
          // }
          // console.log(this.userName + "  " + layers[i].id);
          // if (this.userName === "全部人员") {
          //   layers[i].setData(markers);
          //   this.userRegionGroup.addLayer(layers[i].polygon);
          // } else if (this.userName === layers[i].id) {
          //   this.leftPageData.pageCount = markers.length;
          //   for (let m = 0; m < markers.length; m++) {
          //     if (formatCustomers.length < this.leftPageData.pageSize) {
          //       formatCustomers.push(markers[m].attrs);
          //     }
          //   }
          //   layers[i].setData(markers);
          //   this.userRegionGroup.addLayer(layers[i].polygon);
          // } else {
          //   layers[i].setData([]);
          // }
        }
        if (this.userName === "全部人员") {
          this.leftPageData.pageCount = this.oMarkers.length;
          for (let f = 0; f < this.oMarkers.length; f++) {
            if (formatCustomers.length < this.leftPageData.pageSize) {
              formatCustomers.push(this.oMarkers[f].attrs);
            }
          }
        }
        this.currentPage = 1;
        this.tableDatas = formatCustomers;
      }
      this.getDistrictCount();
      this.createLegend();
    },
    openLoading: function (text) {
      this.isLoading = true;
      this.loadingText = text;
    },
    closeLoading: function () {
      let self = this;
      setTimeout(function () {
        self.isLoading = false;
      }, 500);
    },
    fitBounds () {
      let bounds = new L.latLngBounds();
      let features = this.allMarkers;
      for (let i = 0; i < features.length; i++) {
        let feature = features[i];
        if (feature) {
          let position = L.latLng(
            feature.point.coordinates[1],
            feature.point.coordinates[0]
          );
          bounds.extend(position);
        }
      }
      if (bounds.isValid()) {
        this.map.flyToBounds(bounds);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Customers.vue